<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <px-input-money
            label="Valor do frete"
            class="required"
            :error="$v.resposta.total.$error"
            @blur="$v.resposta.total.$touch()"
            v-model="resposta.total"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-select-enum
            label="Aplicação ICMS"
            class="required"
            :error="$v.resposta.tipoAplicacaoIcms.$error"
            @blur="$v.resposta.tipoAplicacaoIcms.$touch()"
            @change="onChangeAplicacaoIcms"
            v-model="resposta.tipoAplicacaoIcms"
            :items="aplicacoesImpostoIcms"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-input-percentage
            label="ICMS"
            class="required"
            ref="icms"
            :error="$v.resposta.icms.$error"
            @blur="$v.resposta.icms.$touch()"
            :disabled="isIcmsIsento"
            v-model="resposta.icms"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <px-select-enum label="Forma de pagamento"
                          class="required"
                          :error="$v.resposta.formaPagamento.$error"
                          @blur="$v.resposta.formaPagamento.$touch()"
                          v-model="resposta.formaPagamento"
                          :items="formasPagamentos"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <px-autocomplete-prazo-pagamento
            :class="{'required': !isAVista}"
            :disabled="isAVista"
            :error="$v.resposta.prazoPagamento.$error"
            @blur="$v.resposta.prazoPagamento.$touch()"
            v-model="resposta.prazoPagamento"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <px-date-picker label="Validade da cotação"
                          v-model="resposta.validade"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <px-input-number label="Prazo de entrega (dias corridos)"
                           class="required"
                           :error="$v.resposta.prazoEntrega.$error"
                           @blur="$v.resposta.prazoEntrega.$touch()"
                           v-model="resposta.prazoEntrega"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="11">
          <v-textarea
            outlined
            v-model="resposta.observacao"
            label="Observações"
            counter="1500"
            rows="1"
          />
        </v-col>
        <v-col cols="12" sm="1">
          <px-anexo v-model="resposta.arquivos"
                    :max="3"
                    upload-base-path="fornecedor/files"
                    @loading="onFileLoad"/>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary"
             :loading="loading"
             @click="onSend">
        Enviar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AplicacaoImposto, FormaPagamento } from 'px-business-components';
import { required, requiredIf } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import validationFileMixin from '@/mixins/validation-file-mixin';
import CotacaoFreteService from '../cotacoes-service';

export default {
  mixins: [validationMixin, validationFileMixin],
  props: {
    solicitacao: Object,
    editing: Boolean,
    editResposta: Object,
  },
  data() {
    return {
      loading: false,
      formasPagamentos: FormaPagamento.values,
      aplicacoesImpostoIcms: AplicacaoImposto.values
        .filter((item) => item.key !== AplicacaoImposto.keys.CALCULAR.key),
      resposta: {
        transportadora: this.solicitacao.transportadora,
        cotacaoFrete: this.solicitacao.cotacaoFrete,
        total: null,
        tipoAplicacaoIcms: null,
        icms: null,
        formaPagamento: null,
        prazoPagamento: null,
        validade: null,
        prazoEntrega: null,
        observacao: null,
        arquivos: [],
      },
    };
  },
  computed: {
    isIcmsIsento() {
      return this.resposta.tipoAplicacaoIcms
        === AplicacaoImposto.keys.ISENTO.key;
    },
    isAVista() {
      return this.resposta.formaPagamento === FormaPagamento.keys.A_VISTA.key;
    },
  },
  methods: {
    onChangeAplicacaoIcms() {
      if (this.isIcmsIsento) {
        // workaround para zerar v-money
        this.$refs.icms.$el.getElementsByTagName('input')[0].value = 0;
        this.resposta.icms = 0;
      }
    },
    onSend() {
      if (this.validateForm() || this.validateFile()) {
        return;
      }
      this.loading = true;
      CotacaoFreteService.responder(this.resposta)
        .then(({ data }) => {
          this.$toast('Resposta enviada', { color: 'success' });
          this.$emit('ready', data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setupEditing() {
      if (this.editing) {
        this.resposta = this.editResposta;
        this.resposta.total = this.resposta.total.toFixed(2);
        this.resposta.icms = this.resposta.icms
          ? (this.resposta.icms * 100).toFixed(2) : 0;
      }
    },
  },
  watch: {
    'resposta.formaPagamento': function onChangeFormaPagamento() {
      if (this.isAVista) {
        this.resposta.prazoPagamento = null;
      }
    },
  },
  created() {
    this.setupEditing();
  },
  validations: {
    resposta: {
      total: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      tipoAplicacaoIcms: {
        required,
      },
      icms: {
        required,
      },
      formaPagamento: {
        required,
      },
      prazoPagamento: {
        required: requiredIf(function () {
          return !this.isAVista;
        }),
      },
      prazoEntrega: {
        required,
      },
    },
  },
};
</script>
